import React, {useState} from 'react';
import ReactInputMask from "react-input-mask";

const ClientFields = (props) => {

    return (
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label>Телефон</label>
                    <ReactInputMask mask="+7 (999) 999-99-99" type="text" className="form-control"
                                    placeholder="Номер телефона" value={props.client.phone}
                                    onChange={(e) => props.setClient({...props.client, phone: e.target.value})}
                    />
                </div>
                <div className="form-group">
                    <label>Скидка</label>
                    <input type="number" value={props.client.discount} onChange={(e) => props.setClient({...props.client, discount: e.target.value})} className="form-control"/>
                </div>
                <div className="form-group">
                    <label>Тип клиента</label>
                    <select value={props.client.type} onChange={(e) => props.setClient({...props.client, type: e.target.value})} className="form-control">
                        <option value="">Рядовой</option>
                        <option value="vip">VIP</option>
                        <option value="bl">BL Черный список</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Место работы</label>
                    <input type="text" value={props.client.work} onChange={(e) => props.setClient({...props.client, work: e.target.value})} className="form-control"/>
                </div>
                <div className="form-group">
                    <label>Должность</label>
                    <input type="text" value={props.client.position} onChange={(e) => props.setClient({...props.client, position: e.target.value})} className="form-control"/>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label>Фамилия</label>
                    <input type="text" value={props.client.last_name} onChange={(e) => props.setClient({...props.client, last_name: e.target.value})} className="form-control"/>
                </div>
                <div className="form-group">
                    <label>Имя</label>
                    <input type="text" value={props.client.name} onChange={(e) => props.setClient({...props.client, name: e.target.value})} className="form-control"/>
                </div>
                <div className="form-group">
                    <label>Отчество</label>
                    <input type="text" value={props.client.second_name} onChange={(e) => props.setClient({...props.client, second_name: e.target.value})} className="form-control"/>
                </div>
                <div className="form-group">
                    <label>Дата рождения</label>
                    <input type="date" value={props.client.birthday} onChange={(e) => props.setClient({...props.client, birthday: e.target.value})} className="form-control"/>
                </div>
            </div>
        </div>
    );
};

export default ClientFields;